// 1. Import `extendTheme`
import { extendTheme } from "@chakra-ui/react"

// 2. Call `extendTheme` and pass your custom values
const theme = extendTheme({
  colors: {
    brand: {
      50: '#ffe7e1',
      100: '#febeb5',
      200: '#f89488',
      300: '#f36a59',
      400: '#ee412a',
      500: '#d52711',
      600: '#a61e0c',
      700: '#771407',
      800: '#4a0902',
      900: '#200000',
    },
    gray: {
      50: '#efe4ff',
      100: '#cdb3ff',
      200: '#ab80ff',
      300: '#894dfe',
      400: '#691cfd',
      500: '#4f03e4',
      600: '#3d01b2',
      700: '#2b0080',
      800: '#1a004f',
      900: '#0a001f',
    }
  },
})

export default theme